import { useRuntime } from './useRuntime';

export const usePath = () => {
  const {
    page: { path },
  } = useRuntime();

  return {
    isHomepage: /^index\.?/.test(path),
    isRatgeberPage:
      /^mietwagen-ratgeber/.test(path) || /^guide-location-voiture/.test(path),
    isMallorcaPage: /^mietwagen-mallorca/.test(path),
  };
};
